// Helper function to get the full image URL
export const getImageUrl = (url) => {
  if (!url) return '';
  
  // If the URL is already absolute (starts with http:// or https://), return as is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Otherwise, prepend the API base URL
  const apiBaseUrl = process.env.REACT_APP_API_URL || '';
  return `${apiBaseUrl}${url}`;
}; 